import { ReactElement, Suspense } from "react";
import CardCollectionSkeleton from "../LetterbooksBooks/LetterbooksCollection/CardCollection/CardCollectionSkeleton/CardCollectionSkeleton";
import ShelfCollectionSkeleton from "../LetterbooksBooks/LetterbooksCollection/ShelfCollection/ShelfCollectionSkeleton/ShelfCollectionSkeleton";
import LetterbooksViewType from "types/LetterbooksViewType";

interface LetterbookOptions {
  children: ReactElement;
  view: LetterbooksViewType;
}

const Skeletons = {
  card: CardCollectionSkeleton,
  table: CardCollectionSkeleton,
  bluk: CardCollectionSkeleton,
  shelf: ShelfCollectionSkeleton,
};

export default function LetterbooksLoadingSkeleton({
  view,
  children,
}: LetterbookOptions) {
  const Skeleton = Skeletons[view];
  return <Suspense fallback={<Skeleton />}>{children}</Suspense>;
}
